import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { Row, Col, Button } from "reactstrap";
import { UserDetailsTable } from './view/UserDetailsTable';
import { ROUTE_ADMIN_MANAGE } from '../../../../../config/routes';
import { ACL } from '../../../../../config/constants';

function UserDetailsTab(props) {
  const { user, toggleEditMode } = props;

  return (
    <div className="admin-user-detail-section admin-user-detail-section--details">
      <div className="admin-user-detail-table">
        <UserDetailsTable user={user}/>
      </div>
        <Row className="admin-user-detail-section__actions mt-2 text-right justify-content-md-end">
          <Col lg="auto" className="mb-2 mb-xl-0">
            {ACL.ADMIN.USERS.EDIT.hasAccess() && (user && user.id) && <Button
              color="primary"
              className="btn-warning"
              type="button"
              onClick={() => {
                toggleEditMode( "user", true );
              }}
            >
              <FormattedMessage id="button.edit"/>
            </Button>}
            <Link className="btn btn-secondary" to={ROUTE_ADMIN_MANAGE}>
              <FormattedMessage id="messages.go_back"/>
            </Link>
          </Col>
        </Row>
    </div>
  );
}

export { UserDetailsTab };
